import { Molecule, wrap } from 'AppReact';
import styled, { css } from 'styled-components';
import { SecondaryTextXs, Icon } from 'atoms';
import { Mr1 } from 'wrappers';
import { CloseSvg } from 'components/icons';
import { Button } from './atoms';

const template = styled.div`
  ${({ theme }) => css`
    border-radius: 20px;
    border: 1px solid #E3E3E3;
    display: flex;
    width: fit-content;
    align-items: center;
    padding-left: 8px;
    height: 30px;
    background: #FFFFFF;
    white-space: nowrap;
  `}
`;

export default Molecule({
  template,
  atoms: [
    {
      component: wrap(SecondaryTextXs, Mr1),
      name: 'Text',
      renderIf: ({ text }) => !!text,
      displayValue: ({ text }) => text
    },
    {
      component: wrap(Icon, Mr1),
      name: 'Text',
      renderIf: ({ icon }) => !!icon,
      displayValue: ({ icon }) => icon
    },
    {
      component: Button,
      name: 'Button',
      displayValue: ({ }) => CloseSvg({ width: 14, height: 14 })
    }
  ],
})